import api, { getAuthParams } from './client';

export const getPreferredCompanies = (params) =>
  api.get('/companies/preferred', { params: { ...getAuthParams(), ...params } });

export const getCompanySuggestions = (search, params = {}) =>
  api.get('/companies/suggestions', {
    params: { search, limit: 20, ...getAuthParams(), ...params },
  });
